(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c3dp-assembled-pet"] && !Shopify.designMode) return;
  try {
    
function initializePetGallery(root) {
  root.querySelectorAll('[data-pet-page]').forEach(page => {
    if (page.dataset.petReady) return;
    page.dataset.petReady = 'true';
    page.addEventListener('click', event => {
      const button = event.target.closest('[data-pet-select]');
      if (!button) return;
      page.querySelectorAll('[data-pet-photo]').forEach(photo => { photo.hidden = photo.dataset.petPhoto !== button.dataset.petSelect; });
      page.querySelectorAll('[data-pet-select]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    });
  });
}
document.querySelectorAll('[data-pet-calculator]').forEach(calc=>{const update=()=>{const count=Math.max(0,Math.min(1000,Number(calc.querySelector('[data-pet-bottles]').value)||0));const cost=Math.max(0,Math.min(500,Number(calc.querySelector('[data-pet-cost]').value)||0));const size=calc.querySelector('[data-pet-size]').value;const lo=count*4.33*(size==='1'?12:25)/1000;const hi=count*4.33*(size==='1'?15:30)/1000;calc.querySelector('[data-pet-mass]').textContent=lo.toFixed(2)+'–'+hi.toFixed(2)+' kg';calc.querySelector('[data-pet-value]').textContent='$'+Math.round(lo*cost)+'–$'+Math.round(hi*cost)+' USD';};calc.addEventListener('input',update);update();});
initializePetGallery(document);
document.addEventListener('shopify:section:load', event => initializePetGallery(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luminark-project"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('luminark-project')) {
  customElements.define('luminark-project', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const selector = this.querySelector('[data-lp-variant]');
      const update = () => {
        const option = selector.selectedOptions[0];
        this.querySelectorAll('[data-lp-price]').forEach(el => el.textContent = option.dataset.price);
        const submit = this.querySelector('[data-lp-submit]');
        submit.disabled = option.dataset.available !== 'true';
        submit.textContent = submit.disabled ? submit.dataset.sold : submit.dataset.ready;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      };
      selector.addEventListener('change', update);
      const calc = this.querySelector('[data-lp-calculator]');
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:calc.dataset.currency}).format(value);
      const usd = value => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(value);
      const calculate = () => {
        const inputs = ['grams','spool','hardware','fixings'].map(key => this.querySelector('[data-lp-'+key+']'));
        const [grams,spool,hardware,fixings] = inputs.map(input => Number(input.value));
        const valid = inputs.every(input => input.value !== '' && input.validity.valid);
        const option = selector.selectedOptions[0];
        const allocation = Number(option.dataset.cents)/100/Number(calc.dataset.count);
        const material = grams/1000*spool;
        this.querySelectorAll('[data-lp-design-price]').forEach(el => el.textContent=money(allocation));
        this.querySelector('[data-lp-license]').textContent=option.dataset.license;
        this.querySelector('[data-lp-weight]').textContent=valid ? grams+' g' : '—';
        this.querySelector('[data-lp-material]').textContent=valid ? usd(material) : '—';
        this.querySelector('[data-lp-hardware-total]').textContent=valid ? usd(hardware) : '—';
        this.querySelector('[data-lp-fixings-total]').textContent=valid ? usd(fixings) : '—';
        this.querySelector('[data-lp-total]').textContent=valid ? (calc.dataset.currency==='USD' ? usd(material+hardware+fixings+allocation) : usd(material+hardware+fixings)+' + '+money(allocation)) : '—';

      };
      this.querySelectorAll('.lp-cost-inputs input').forEach(input=>input.addEventListener('input',calculate));
      selector.addEventListener('change',calculate);
      calculate();
      const bundleSelects=Array.from(this.querySelectorAll('[data-lp-bundle-select]'));
      const updateBundle=()=>{
        const one=this.querySelector('[data-lp-bundle-select="1"]').selectedOptions[0];
        const two=this.querySelector('[data-lp-bundle-select="2"]').selectedOptions[0];
        const original=Number(one.dataset.cents)+Number(two.dataset.cents);
        const saving=Math.round(original*0.15);
        const total=original-saving;
        const code=one.dataset.license==='Commercial' ? (two.dataset.license==='Commercial'?'LUMINARK-DUO-COMMERCIAL-15':'LUMINARK-DUO-CP-15') : (two.dataset.license==='Commercial'?'LUMINARK-DUO-PC-15':'LUMINARK-DUO-PERSONAL-15');
        this.querySelectorAll('[data-lp-bundle-was]').forEach(el=>el.textContent=money(original/100));
        this.querySelectorAll('[data-lp-bundle-price]').forEach(el=>el.textContent=money(total/100));
        this.querySelectorAll('[data-lp-bundle-savings]').forEach(el=>el.textContent=money(saving/100));
        this.querySelectorAll('[data-lp-unit-was]').forEach(el=>el.textContent=money(original/6400));
        this.querySelectorAll('[data-lp-unit-price]').forEach(el=>el.textContent=money(total/6400));
        this.querySelectorAll('[data-lp-bundle-selection]').forEach(el=>el.textContent='Luminark 1.0: '+one.dataset.license+' · Luminark 2.0: '+two.dataset.license);
        const available=one.dataset.available==='true'&&two.dataset.available==='true';
        this.querySelectorAll('[data-lp-buy-bundle]').forEach(link=>{
          link.setAttribute('aria-disabled',String(!available));
          link.querySelector('[data-lp-buy-label]').textContent=available?link.dataset.ready:link.dataset.unavailable;
          if(available)link.href=this.dataset.lpCartUrl+'/'+one.value+':1,'+two.value+':1?discount='+code;
          else link.removeAttribute('href');
        });
      };
      bundleSelects.forEach(select=>select.addEventListener('change',()=>{
        bundleSelects.filter(other=>other.dataset.lpBundleSelect===select.dataset.lpBundleSelect).forEach(other=>other.value=select.value);
        updateBundle();
      }));
      selector.addEventListener('change',()=>{
        bundleSelects.filter(select=>select.dataset.lpBundleSelect===this.dataset.lpCurrent).forEach(select=>select.value=selector.value);
        updateBundle();
      });
      updateBundle();
      const dialog=this.querySelector('[data-lp-bundle]');
      this.querySelectorAll('[data-lp-bundle-open]').forEach(button=>button.addEventListener('click',()=>dialog.showModal()));
      this.querySelector('[data-lp-bundle-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      const related=this.querySelector('[data-lp-related]');
      const preview=new URL(window.location.href).searchParams.get('preview_theme_id');
      if(preview){const link=new URL(related.href);link.searchParams.set('preview_theme_id',preview);related.href=link;}
      const track=this.querySelector('[data-lp-track]');
      const slides=Array.from(this.querySelectorAll('[data-lp-slide]'));
      const thumbs=Array.from(this.querySelectorAll('[data-lp-thumb]'));
      let current=0;
      const go=index=>track.scrollTo({left:Math.max(0,Math.min(index,slides.length-1))*track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      const position=()=>{current=Math.round(track.scrollLeft/track.clientWidth);this.querySelector('[data-lp-position]').textContent=(current+1)+' / '+slides.length;thumbs.forEach((button,index)=>button.setAttribute('aria-pressed',String(index===current)));slides.forEach((slide,index)=>{const image=slide.querySelector('[data-lp-motion-image]');if(image&&index!==current&&image.getAttribute('src')!==image.dataset.poster){image.src=image.dataset.poster;const button=slide.querySelector('[data-lp-motion]');button.textContent=button.dataset.play;button.setAttribute('aria-pressed','false');}});};
      track.addEventListener('scroll',position,{passive:true});
      this.querySelector('[data-lp-prev]').addEventListener('click',()=>go(current-1));
      this.querySelector('[data-lp-next]').addEventListener('click',()=>go(current+1));
      thumbs.forEach(button=>button.addEventListener('click',()=>go(Number(button.dataset.lpThumb))));
      track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'){event.preventDefault();go(current+1);}if(event.key==='ArrowLeft'){event.preventDefault();go(current-1);}});
      this.querySelectorAll('[data-lp-motion]').forEach(button=>button.addEventListener('click',()=>{const image=button.parentElement.querySelector('[data-lp-motion-image]');const play=button.getAttribute('aria-pressed')!=='true';image.src=play?image.dataset.gif:image.dataset.poster;button.textContent=play?button.dataset.pause:button.dataset.play;button.setAttribute('aria-pressed',String(play));}));
      position();
      const filters = this.querySelector('.lp-filters');
      let active = 'all';
      const displayCards = () => {
        this.querySelectorAll('[data-lp-series]').forEach(card => {
          card.hidden = active !== 'all' && card.dataset.lpSeries !== active;
        });
      };
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-lp-filter]');
        if (!button) return;
        active = button.dataset.lpFilter;
        filters.querySelectorAll('button').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
        displayCards();
      });
      displayCards();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            jdgm.customizeBadges();
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
